import React, { memo } from 'react';

const InfoCard = memo(({card}) => {
    const {name,description,icon,bgClass}=card;

    return (
        <div className={`card card-side shadow-xl my-3 text-white ${bgClass} p-5`}>
        <figure><img className='w-28' src={icon} alt="Movie"/></figure>
        <div className="card-body">
          <h2 className="card-title">{name}</h2>
          <p>{description}</p>
          
        </div>
      </div>
    );
});

export default InfoCard;